import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, ensureBoolean, stageSorting, isNotEmpty, getRemotedbUrl, isEmpty, stripTags } from '../../lib/ep.js';

import ActionLink from '../builder/ActionLink';
import TimeCounterSimple from '../builder/TimeCounterSimple';

import BracketMosaic from '../front/BracketMosaic';
import StageMosaic from '../front/StageMosaic';
import VideoEmbed from '../front/VideoEmbed';

import ButtonQuizStats from '../front/quiz/ButtonQuizStats';
import LeveledHTMLText from '../front/helpers/LeveledHTMLText.js';
import EnterButton from '../front/buttons/EnterButton.js';
import TermsButton from '../front/buttons/TermsButton.js';
import WinnersButton from '../front/buttons/WinnersButton.js';
import EntriesButton from '../front/buttons/EntriesButton.js';
import PrizeGalleryButton from '../front/buttons/PrizeGalleryButton.js';
import { BlockDisplay } from '../../ts/components/BlockEditor.tsx';
import ViewCurrentUsers from '../front/ViewCurrentUsers.js';

const PromotionLanding = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const promotion = props?.promotion?.Promotion ?? false;
	const is_builder = props?.is_builder ?? false;
	const oldpromohidecount = props?.oldpromohidecount ?? false;

	const status = promotion?.promo_status ?? (props?.promo_status ?? 'closed');

	let promo_status_ribbon_label = "";
	let promo_status_ribbon_class = '';
	let num_seconds = 0;
	switch(status) {
		case 'open':
		case 'active':
			num_seconds = props?.num_seconds ?? (moment.tz(promotion.end_entry, promotion.timezone).diff() / 1000);
			promo_status_ribbon_class = 'opened_ribbon';
			promo_status_ribbon_label = "open";
			break;

		case 'pending':
			num_seconds = props?.num_seconds ?? (moment.tz(promotion.start_entry, promotion.timezone).diff() / 1000);
			promo_status_ribbon_class = 'coming_soon_ribbon';
			promo_status_ribbon_label = "coming soon";
			break;

		case 'closed':
		default:
			num_seconds = -1;
			promo_status_ribbon_class = 'closed_ribbon';
			promo_status_ribbon_label = "closed";
			break;
	}

	const promo_status = {
		num_seconds,
		status,
		ribbon_class:promo_status_ribbon_class,
		ribbon_label:promo_status_ribbon_label,
	}

	const is_multistage = promotion?.is_multistage ?? false;

	if(promotion === false) return null;

	const goToGalleries = () => {
		if(is_builder) return null;
		self.location.href = getRemotedbUrl(`/gallery/${promotion.id}`);
	};

	const goToStageResults = () => {
		if(is_builder) return null;
		self.location.href = getRemotedbUrl(`/results/${promotion.id}/${props.stages[0].Stage.id}`);
	};

	const questions = props?.questions ?? [];
	const stages = props?.stages ?? [];

	let main_image = false;
	let main_video = false;
	if(promotion.image != "") {
		main_image = promotion.full_image;
	} else if(promotion.video_swf != "") {
		main_video = promotion.video_swf;
	}

	const hide_toc = ensureBoolean(promotion?.config?.hide_toc ?? false);

	const display_toc = ((promotion.toc || promotion.external_toc_url != undefined) && !hide_toc) ? true : false;
	const display_quiz_stats = false;
	const display_winners = (promotion.win_published == '1') ? true : false;
	const display_prize_gallery = promotion?.loyalty_in_landing ?? false;
	const landing_image_only = promotion?.landing_image_only ?? false;

	const display_status = (!ensureBoolean(promotion?.config?.layout?.hide_status ?? false)) ? true : false;
	const display_current_users = (ensureBoolean(promotion?.show_current_users ?? '1') && !oldpromohidecount) ? true : false;
	const display_list_users = (display_current_users && promotion.show_list_users) ? promotion.show_list_users : false;

	const has_ranking = promotion?.has_ranking ?? false;

	let enter_to_vote = promotion?.enter_to_vote ?? false;
	if(!['45', '55', '56', '58'].includes(promotion.promotion_type_id)) enter_to_vote = false;

	const custom_labels = promotion?.custom_labels ?? {};
	const enter_button_label = (isNotEmpty(custom_labels, 'enter_button')) ? custom_labels.enter_button : i18n(((enter_to_vote) ? "vote" : "Enter"), 'ucfirst');
	const entries_button_label = (isNotEmpty(custom_labels, 'view_entries_button')) ? custom_labels.view_entries_button : i18n((has_ranking) ? "Ranking" : "Gallery");
	const galleries_button_label = (isNotEmpty(custom_labels, 'view_galleries_button')) ? custom_labels.view_galleries_button : i18n("View gallery");

	const has_bracket_mosaic_enabled = (promotion.brackets_enabled != undefined && promotion.brackets_enabled && promotion.brackets_in_landing != undefined) ? promotion.brackets_in_landing : false;

	let has_stage_mosaic_enabled = (is_multistage && (promotion?.stages_in_landing ?? false)) ? true : false;
	const st_segment = stages.find((s) => (s.Stage.segment_id != undefined && s.Stage.segment_id.length > 0));
	const segments_in_stage = (st_segment != undefined && st_segment.Stage != undefined) ? true : false;
	if(segments_in_stage) has_stage_mosaic_enabled = false;

	stageSorting(stages, ((promotion.stages_mosaic_sort_mode == undefined) ? 'date' : stages), promotion.stages_mosaic_sort_mode);

	const display_register_button = (!promotion.hide_enter_button || promotion.hide_enter_button == '0' || questions.length > 0 || promotion.promotion_type_id == '25') ? true : false;

	let has_galleries_enabled = promotion?.galleries_enabled ?? false;
	if(promotion?.enter_to_vote ?? false) has_galleries_enabled = false;

	let display_stage_results = false;

	let stage_results_button_label = "See winner team";
	if(stages.length == 1) {
		if((stages[0].Stage?.team_results_publish ?? '0') != '0') {
			display_stage_results = true;
			if((stages[0].Stage?.team_results_button ?? "") != "") stage_results_button_label = stages[0].Stage.team_results_button;
		}
	}

	let display_promo_extras = false;
	if(has_bracket_mosaic_enabled || display_toc || display_quiz_stats || display_winners || display_prize_gallery || (!has_stage_mosaic_enabled && !has_bracket_mosaic_enabled && (display_status || display_current_users))) display_promo_extras = true;

	const info_classes = ['promo_info_flex'];

	let num_cols = 0;
	if(display_status) {
		info_classes.push('with_status');
		num_cols++;
	}
	if(display_current_users) {
		info_classes.push('with_users');
		num_cols++;
	}
	info_classes.push(`has_${num_cols}_cols`);

	const buttons_in_top = ensureBoolean(promotion?.config?.buttons_in_top ?? false);

	const classes = ['layout_conts'];
	if(buttons_in_top) classes.push('buttons_in_top');

	return (
		<div class={classes.join(" ")}>
			<div class="flex_cols">
				{(main_image || main_video) && (
					<div class="flex_col col_1">
						<div class="main_media_flex">
							{(main_image) && (
								<div class="main_img_promo">
									<EnterButton
										promotion={promotion}
										is_builder={is_builder}
										icon={false}
										custom_content={<img
											src={main_image}
											alt={stripTags(promotion.title, true)}
											class="promo"
											style={{ maxWidth:'100%' }}
										/>}
									/>
								</div>
							)}

							{(main_video) && (
								<VideoEmbed
									video_url={main_video.full_url}
									video_thumb={main_video.image}
								/>
							)}
						</div>
					</div>
				)}

				{(!landing_image_only || main_image === false) && (
					<div class="flex_col col_2">
						<article class="promo_desc gui_main_text_color_on_bg main_text_flex">
							{(isNotEmpty(promotion, 'title')) && (
								<LeveledHTMLText
									_class={{ other:'promotion_title' }}
								>{promotion.title}</LeveledHTMLText>
							)}

							{(isNotEmpty(promotion, 'description') && isEmpty(promotion, 'description_block')) && (
								<LeveledHTMLText
									_class={{ other:'fill_description' }}
								>{promotion.description}</LeveledHTMLText>
							)}

							{(promotion?.description_block) && (
								<BlockDisplay
									blocks={promotion.description_block}
									locale='eng'
								/>
							)}
						</article>

						{(has_stage_mosaic_enabled) && (
							<article class="stages_in_landing" style={{ order:5 }}>
								<StageMosaic
									brackets={window.brackets}
									stages={stages}
									promo={promotion}
									is_builder={is_builder}
								/>
							</article>
						)}

						{(!has_stage_mosaic_enabled || has_bracket_mosaic_enabled) && (
							<article class="promo_data template_module info_flexwrap gui_main_actions">
								{(display_register_button) && (
									<div class="template_submodule call_to_action_flex enter_flexwrap">
										<div class="enter flex_button gui_big_button register_flex">
											<EnterButton
												autotranslate={false}
												promotion={promotion}
												is_builder={is_builder}
												icon={false}
											>{enter_button_label}</EnterButton>
										</div>
									</div>
								)}

								{(display_stage_results) && (
									<div class="template_submodule results_button_flex entries_button_flex">
										<div class="view_stage_results">
											<ActionLink
												onClick={goToStageResults}
												autotranslate={false}
											>{stage_results_button_label}</ActionLink>
										</div>
									</div>
								)}

								{(has_galleries_enabled) && (
									<div class="template_submodule entries_button_flex">
										<span class="view_galleries">
											<ActionLink
												onClick={goToGalleries}
												autotranslate={false}
											>{galleries_button_label}</ActionLink>
										</span>
									</div>
								)}

								{(promotion.public_entries != '0') && (
									<div class="template_submodule entries_button_flex">
										{(!has_ranking || !display_register_button) ? (
											<div class="view_entries flex_button gui_big_button">
												<EntriesButton
													promotion={promotion}
													is_builder={is_builder}
													icon={false}
												>{entries_button_label}</EntriesButton>
											</div>
										) : (
											<span class="view_entries">
												<EntriesButton
													promotion={promotion}
													is_builder={is_builder}
													icon={false}
												>{entries_button_label}</EntriesButton>
											</span>
										)}
									</div>
								)}
							</article>
						)}

						{(display_promo_extras) && (
							<article class="promo_data template_module info_flexwrap promo_extra">
								{(has_bracket_mosaic_enabled) && (
									<article class="brackets_in_landing">
										<BracketMosaic
											basename='landing'
											brackets={window.brackets.brackets}
											candidates={window.brackets.candidates}
											matches={window.brackets.matches}
											is_builder={is_builder}
											promo={promotion}
										/>
									</article>
								)}

								{(display_toc || display_quiz_stats || display_winners || display_prize_gallery) && (
									<div class="template_submodule small_actions_flex">
										{(display_toc) && (
											<TermsButton
												promotion={promotion}
												is_builder={is_builder}
												icon={false}
											/>
										)}

										{(display_winners) && (
											<WinnersButton
												promotion={promotion}
												is_builder={is_builder}
												icon={false}
											/>
										)}

										{(display_prize_gallery) && (
											<PrizeGalleryButton
												promotion={promotion}
												is_builder={is_builder}
												icon={false}
											/>
										)}

										{(display_quiz_stats) && (
											<ButtonQuizStats
												promotion={{ Promotion:promotion }}
												is_builder={is_builder}
												button_label={promotion?.quiz_stats_link ?? "View statistics"}
												type='link'
											/>
										)}
									</div>
								)}

								{(!has_stage_mosaic_enabled && !has_bracket_mosaic_enabled) && (
									<div class={info_classes.join(" ")}>
										{(display_status) && (
											<div class="promo_timing_flex">
												<article class="promo_specs promotion_dates template_submodule gui_module">
													<div class="dates_mod registration_info">
														<ul class="gui_ribbons">
															<li
																class={`ribbon ${promo_status.ribbon_class}`}
															>{i18n(promo_status.ribbon_label, 'ucfirst')}</li>
														</ul>

														{(promo_status.num_seconds > 0) && (
															<span class="value gui_main_text_color_on_bg hb_mainFontWeightRoman">
																<TimeCounterSimple
																	seconds={promo_status.num_seconds}
																/>
															</span>
														)}
													</div>
												</article>
											</div>
										)}

										{(display_current_users) && (
											<div class="entries_info_flex">
												<article class="entrants_counter gui_module template_submodule gui_main_text_color_on_bg">
													<div class="current_entries">
														<span
															class="value knk-entries hb_mainFontWeightRoman"
														>{promotion?.current_users ?? '0'}</span>

														{(display_list_users) && (
															<ViewCurrentUsers
																promotion={{ Promotion:promotion }}
															/>
														)}
													</div>
												</article>
											</div>
										)}
									</div>
								)}
							</article>
						)}
					</div>
				)}
			</div>
		</div>
	)
};

export default injectIntl(PromotionLanding);